import http from 'plugins/axios';

export default {
    // 获取所有所属链
    getChainType() {
        return http.get({
            url: '/admin/blindBoxCoin/chainType/list'
        });
    },


    //获取NFT列表
    getNFTList(data) {
        return http.get({
            url: `/admin/blindBoxCoin/listByPage`,
            data: data
        });
    },


    //添加盒子
    createOrUpdate(data) {
        return http.post({
            url: `/admin/blindBoxCoin/addOrUpdate`,
            data: data
        });
    },

    // 上传哈希
    createHash(data) {
        return http.post({
            url: `/admin/blindBoxCoin/upload/hash`,
            data: data,
            dataType: 'form'
        });
    },

    // 查询盒子详情
    getNFTInfo(data) {
        return http.get({
            url: `/admin/blindBoxCoin/info`,
            data: data
        });
    },

    // 查看提现申请
    getApply(data) {
        return http.get({
            url: `/admin/blindBoxCoin/see/withdrawal/apply`,
            data: data
        })
    },

    // 查看提现凭证
    getVoucher(data) {
        return http.get({
            url: '/admin/blindBoxCoin/see/withdrawal/voucher',
            data: data
        })
    },

    //删除盒子
    deleteNFT(data) {
        return http.post({
            url: `/admin/blindBoxCoin/logic/delete`,
            data: {
                id: data
            },
            dataType: 'form'
        });
    },
    // 同步NFT盒子
    syncNftBox(data) {
        return http.post({
            url: '/admin/blindBoxCoin/sync/coin',
            data,
            dataType: 'form'
        })
    }

};
